import React from "react";
import { Route, Redirect } from "react-router-dom";

import { Spinner } from "../../components";

const AuthenticatedRoute = ({ component: Component, auth, ...rest }) => (
  <Route
    {...rest}
    render={props =>
      auth.isAuthenticated() ? (
        <Component auth={auth} {...props} />
      ) : (
        <div>
          <Spinner message="Redirecting you to login page" />
          <Redirect
            to={{
              pathname: "/login",
              state: { from: props.location }
            }}
          />
        </div>
      )
    }
  />
);

export default AuthenticatedRoute;



// WEBPACK FOOTER //
// ./src/components/authenticated_route/AuthenticatedRoute.jsx